import { Outlet } from "@remix-run/react";
import { CommonLayout } from "~/modules/shared/layouts";

export default function CommonLayoutRoute() {
  return (
    <CommonLayout>
      <Outlet />
    </CommonLayout>
  );
}
